import { render } from "./PageTitle.vue?vue&type=template&id=41ef90d2&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=41ef90d2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-41ef90d2"

export default script